import { OnInit, Component } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertService } from 'src/app/shared/services/alert.service';
import { UrlService } from 'src/app/shared/services/url.service';
import { GlobalService } from 'src/app/shared/global.service';
import { DependenciaJefesModel } from 'src/app/models/dependencia-jefes.model';
import { UrlControl } from 'src/app/shared/models/generic.model';
import { UtilService } from 'src/app/shared/services/util.service';
import { DetalleDominio } from 'src/app/models/detalleDominio.Model';
import { ConfirmationModalOptions } from 'src/app/shared/models/modal.model';
import { ConstantesService } from 'src/app/shared/services/constantes.service';
import { DominiosService } from 'src/app/shared/services/dominios.service';
import { FuncionarioModel } from 'src/app/models/funcionario.model';

@Component({
    selector: 'app-relacion-dependencia-jefe',
    templateUrl: './relacion-dependencia-jefe.component.html',
    styleUrls: ['./relacion-dependencia-jefe.component.scss']
})

export class RelacionDependenciaJefeComponent implements OnInit {

    public filtroNombre: string;
    public consultaJefes: DependenciaJefesModel[];
    public BanderaGuardarActualizar: boolean;
    public filtroSede: string;
    public listaSede: DetalleDominio[];
    public campoIdDependencia: number;
    public campoSede: string;
    public campoDependencia: string;
    public campoJefe: string;
    public campoJefeEditar: string;
    public consultaDependencias: DependenciaJefesModel[];
    public modalOptionsGuardar: ConfirmationModalOptions;
    public funcionarios: FuncionarioModel[];
    public mostrarCampoJefe: boolean;
    public habilitarDependenciaSede: boolean;
    public cambioJefe: string;
    public banderaHabilitarGuardar: boolean;
    public sedemodificada: string;
    public dependenciaModificada: string;
    public p: any;

    constructor(
        private global: GlobalService,
        private urlService: UrlService,
        private spinner: NgxSpinnerService,
        private alertService: AlertService,
        private utilService: UtilService
    ) {
        this.consultaJefes = [];
        this.BanderaGuardarActualizar = false;
        this.listaSede = [];
        this.consultaDependencias = [];
        this.campoDependencia = undefined;
        this.campoSede = undefined;
        this.campoJefe = undefined;
        this.funcionarios = [];
        this.habilitarDependenciaSede = false;
    }

    ngOnInit() {
        this.consultarJefes();
        this.obtenerSede();
        this.consultarDependencias();
        this.consultarFuncionarios();
        this.modalOptionsGuardar = new ConfirmationModalOptions(
            'Confirmación',
            ConstantesService.MSJ_CONF_GUARDAR_JEFE,
            'SI', 'NO', 'fa fa-save', true, false, 'Guardar', null, 'btn btnGuardar btn-secondary');
    }

    /**
     * Metodo encargado de consultar las dependencias Existentes
     */
    consultarDependencias() {
        this.spinner.show();
        const serviceProvider = 'consultarDependencia';
        const url = this.urlService.getUrlFuncionario(new UrlControl(serviceProvider, null, null),
            this.urlService.hostAPI_FUNCIONARIOS);
        this.global.postGenerico(url).subscribe(
            data => {
                this.consultaDependencias = data;
                this.spinner.hide();
            }, err => {
                this.cathException('No es posible Obtener las Dependencias');
            }
        );
    }

    /**
     * Metodo encargado de consultar los jefes existentes
     */
    consultarJefes() {
        this.spinner.show();
        const serviceProvider = 'consultarJefes';
        const url = this.urlService.getUrlFuncionario(new UrlControl(serviceProvider, null, null),
            this.urlService.hostAPI_FUNCIONARIOS);
        this.global.postGenerico(url).subscribe(
            data => {
                this.consultaJefes = data;
                this.spinner.hide();
            }, err => {
                this.cathException('No es posible consultar los jefes');
            }
        );
    }

    /**
     * Metodo encargado de obtener las sede existentes
     */
    obtenerSede() {
        this.spinner.show();
        const serviceProvider = 'ObtenerDominio';
        const queryParams: Array<[string, string]> = new Array<[string, string]>();
        queryParams.push(['filterBy=detalleDominioPK.nombreDominio', 'Sede']);
        const url = this.urlService.getUrlFuncionario(new UrlControl(serviceProvider, null, queryParams),
            this.urlService.hostAPI_FUNCIONARIOS);
        this.global.getGenerico(url).subscribe(
            data => {
                this.listaSede = data;
                this.spinner.hide();
            }, err => {
                this.cathException('No es posible Obtener las Sedes');
            }
        );
    }

    /**
     * Metodo que verifica es un nuevo registro o es uno Existente
     */
    guardarJefe(jefe: DependenciaJefesModel) {
        if (jefe) {
            this.campoIdDependencia = jefe.idDependencia;
            this.campoDependencia = jefe.nombreDependencia;
            this.campoSede = jefe.sede;
            this.campoJefeEditar = jefe.tipoIdJefe.concat('-' + jefe.numeroIdJefe);
            this.mostrarCampoJefe = false;
            this.modalOptionsGuardar.disabled = true;
            this.habilitarDependenciaSede = true;
            this.cambioJefe = this.campoJefeEditar;
            this.banderaHabilitarGuardar = true;
        } else {
            this.campoDependencia = undefined;
            this.campoSede = undefined;
            this.campoJefe = undefined;
            this.mostrarCampoJefe = true;
            this.modalOptionsGuardar.disabled = true;
            this.habilitarDependenciaSede = false;
            this.banderaHabilitarGuardar = false;
            this.validacion();
        }
        this.BanderaGuardarActualizar = true;
    }

    /**
     *  Metodo encargado de llamar el servicio de Back para realizar el Guardado
     * @param opcion respuesta del mensaje de confirmacion
     */
    getConfirmationGuardar(opcion: boolean, accion: string) {
        if (opcion[0]) {
            const filtros = this.envioFiltros(accion);
            this.spinner.show();
            const serviceProvider = 'guardarJefe';
            const url = this.urlService.getUrlFuncionario(new UrlControl(serviceProvider, null, null),
                this.urlService.hostAPI_FUNCIONARIOS);
            this.global.postGenerico(url, filtros).subscribe(
                data => {
                    this.consultaJefes = data;
                    this.spinner.hide();
                    this.alertService.generateAlertSuccess('Se guardó información exitosamente', 'Exitoso');
                }, err => {
                    if (err.status === 500) {
                        this.cathException(err.error.message);
                    } else {
                        this.cathException('No es posible guardar el Jefe');
                    }
                }
            );
        }
    }

    /**
     * Metodo que agrupa los campos y los comoca como un filtro para enviar al guardado
     * @param accion si es Guardar o Editar
     */
    envioFiltros(accion) {
        let filtro;
        if (this.utilService.validarCamposObligatorios(this.campoJefe) && accion === 'Guardar') {
            const idFuncionario = this.campoJefe.split('-');
            filtro = {
                nombreDependencia: this.campoDependencia,
                sede: this.campoSede,
                tipoIdJefe: idFuncionario[0],
                numeroIdJefe: idFuncionario[1],
                valor: 'Guardar'
            };
        } else if (this.utilService.validarCamposObligatorios(this.campoJefeEditar) && accion === 'Editar') {
            const idFunc = this.campoJefeEditar.split('-');
            filtro = {
                idDependencia: this.campoIdDependencia,
                nombreDependencia: this.campoDependencia,
                sede: this.campoSede,
                tipoIdJefe: idFunc[0],
                numeroIdJefe: idFunc[1],
                valor: 'Editar'
            };
        }
        return filtro;
    }

    /**
     * Metodo que valida los campos obligatorios
     */
    campoObligatorios() {
        if (this.cambioJefe === this.campoJefeEditar && this.banderaHabilitarGuardar) {
                this.modalOptionsGuardar.disabled = true;
        } else {
            this.modalOptionsGuardar.disabled = false;
        }

    }

    /**
     * Metodo que realiza las validacionesde los campos obligatorios
     */
    validacion() {
        if (this.utilService.validarCamposObligatorios(this.campoSede) &&
            this.utilService.validarCamposObligatorios(this.campoDependencia) &&
            (this.dependenciaModificada !== this.campoDependencia ||
             this.sedemodificada !== this.campoSede)) {
                this.dependenciaModificada = this.campoDependencia;
                this.sedemodificada = this.campoSede;
                this.obtenerJefe();
            }
    }

    /**
     * Metodo que consulta los funcionario con el la dependencia y sede seleccionada
     */
    consultarFuncionarios() {
        const serviceProvider = 'ObtenerFuncionario';
        const queryParams: Array<[string, string]> = new Array<[string, string]>();
        queryParams.push(['filterBy', this.urlService.encodeURI(
            'tipoFuncionario=' + DominiosService.TIPO_FUNCIONARIO_PLANTA + '&' +
            'estado=' + DominiosService.ESTADO_FUNCIONARIO)]);
        queryParams.push(['orderBy', 'nombreCompleto']);
        const url = this.urlService.getUrlFuncionario(new UrlControl(serviceProvider, null, queryParams),
            this.urlService.hostAPI_FUNCIONARIOS);
        this.global.getGenerico(url).subscribe(
            data => {
                this.funcionarios = data;
                this.spinner.hide();
            }, err => {
                this.cathException('No es posible consultar los jefes');
            }
        );
    }


    /**
     * Metodo que consulta jefe que pertenece a dicha dependencia y sede
     */
    obtenerJefe() {
        const serviceProvider = 'obtenerJefe';
        const queryParams: Array<[string, string]> = new Array<[string, string]>();
        queryParams.push(['nombreDependencia', this.campoDependencia]);
        queryParams.push(['sede', this.campoSede]);
        const url = this.urlService.getUrlFuncionario(new UrlControl(serviceProvider, null, queryParams),
            this.urlService.hostAPI_FUNCIONARIOS);
        this.global.postGenerico(url).subscribe(
            data => {
                let jefeConsultado: DependenciaJefesModel[];
                jefeConsultado = undefined;
                jefeConsultado = data;
                if (jefeConsultado[0].tipoIdJefe) {
                    this.campoJefe = jefeConsultado[0].tipoIdJefe.concat('-').concat(jefeConsultado[0].numeroIdJefe);
                    this.alertService.generateAlertInfo('La dependencia y la sede registrada ya contiene un jefe de área', 'Alerta');
                } else {
                    this.campoJefe = undefined;
                }
                if (!this.banderaHabilitarGuardar && this.utilService.validarCamposObligatorios(this.campoJefe)) {
                    this.modalOptionsGuardar.disabled = false;
                } else {
                    this.modalOptionsGuardar.disabled = true;
                }
            }, err => {
                this.cathException('No es posible consultar el jefe');
            }
        );
    }

    /**
     * Metodo que valida el campo jefe de area cuando se quiere guardar una nueva relacion
     */
    validacionJefeGuardar() {
        if (!this.banderaHabilitarGuardar && this.utilService.validarCamposObligatorios(this.campoJefe) 
            && this.utilService.validarCamposObligatorios(this.campoDependencia)) {
            this.modalOptionsGuardar.disabled = false;
        } else {
            this.modalOptionsGuardar.disabled = true;
        }
    }

    /**
     * Metodo registra el nombre de la dependencia para filtrar los registros
     * por dicho nombre
     */
    filtrar() {
        this.spinner.show();
        const serviceProvider = 'consultarJefes';
        const queryParams: Array<[string, string]> = new Array<[string, string]>();
        queryParams.push(['nombreDependencia', this.filtroNombre]);
        queryParams.push(['nombreSede', this.filtroSede]);
        const url = this.urlService.getUrlFuncionario(new UrlControl(serviceProvider, null, queryParams),
            this.urlService.hostAPI_FUNCIONARIOS);
        this.global.postGenerico(url).subscribe(
            data => {
                this.consultaJefes = data;
                if (this.consultaJefes.length <= 0) {
                    this.alertService.generateAlertInfo('La relación para la dependencia o sede consultada no'
                    + ' se encuentra en el sistema por favor verifique', '');
                }
                this.spinner.hide();
            }, err => {
                if (err.status === 500) {
                    this.cathException(err.error.message);
                } else {
                    this.cathException('La relación para la dependencia o sede consultada no'
                    + ' se encuentra en el sistema por favor verifique');
                }
            }
        );
    }

    /**
     * Metodo que realiza la volver a la pantalla principal
     */
    volver() {
        this.spinner.show();
        this.consultarJefes();
        this.obtenerSede();
        this.consultarDependencias();
        this.BanderaGuardarActualizar = false;
        this.spinner.hide();
    }

    /**
     * Método de control de Excepciones
     * @param error mensaje saliente respecto al error ocurrido
     */
    cathException(error) {
        this.alertService.generateAlertError(error, 'Error');
        this.spinner.hide();
    }
}
